/**
 * @module Utilities/Request
 * @desc Request helper funtions
 */

import type { RequestAction } from '../request.d';

import { queryStringify } from './query-stringify';

export function bodyResolver({ payload, type }: RequestAction) {
  const hasPayload = !!payload;

  if (!hasPayload) {
    return undefined;
  }

  if (hasPayload && type === 'JSON') {
    return JSON.stringify(payload);
  }

  const payloadGuard = payload as Record<string, unknown>;

  return queryStringify(payloadGuard, {
    encodeValuesOnly: false,
  });
}
